var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('information-accordion',{attrs:{"collapsed":_vm.collapsed,"sections":_vm.sections},on:{"toggled":_vm.toggled}})}
var staticRenderFns = []

export { render, staticRenderFns }